import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ModalContainer,
  Header,
  Tabs,
} from '@core/dashboard/components/PopoverModal';

import Emojis from './Emojis';
import Reactions from './Reactions';

import { ActionsTabs } from '../interfaces';
import { IActionsContent } from './interfaces';

const ActionsContent = ({
  activeTab,
  onChangeTab,
  onClose,
  isEmojisEnabled,
  isReactionsEnabled,
}: IActionsContent) => {
  const { t: translate } = useTranslation();

  const tabs = [
    ...(isEmojisEnabled
      ? [{ label: translate('actions.emojis'), value: ActionsTabs.Emojis }]
      : []),
    ...(isReactionsEnabled
      ? [
          {
            label: translate('actions.reactions'),
            value: ActionsTabs.Reactions,
          },
        ]
      : []),
  ];

  return (
    <ModalContainer
      header={
        <>
          <Header text={translate('actions.actions')} onClose={onClose} />
          <Tabs active={activeTab} onChange={onChangeTab} tabs={tabs} />
        </>
      }
      hasTabs
    >
      {activeTab === ActionsTabs.Emojis && isEmojisEnabled && <Emojis />}
      {activeTab === ActionsTabs.Reactions && isReactionsEnabled && (
        <Reactions onClose={onClose} />
      )}
    </ModalContainer>
  );
};

export default ActionsContent;
